import Form from "../components/Form";

function LoginForm() {
  return <Form />;
}

export default LoginForm;
